"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "product",
    path: "/products/:id",
    component: "Product",
    params: [{
            name: "id",
            prop: "oid",
        },
    ]
});
let Product = class Product extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    oid;
    onOid(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("oid");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    item;
    async $$load_item() {
        return this.$fn.fetch('read_product', { asResource: true, parameters: { id: this.oid } });
    }
    ux;
    b_7315092382398562_modalBindings;
    b_4615685607825208_to;
    dataMembers = ['item', 'ux', 'b_7315092382398562_modalBindings', 'b_4615685607825208_to'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                item: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_4615685607825208_to: {
                    name: "app.products",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: [this.item.name || this.item.number,
                    this.$fn.gettext("Product"),
                ],
                icon: this.$config.product.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_4010_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_8320016629450276_clickPreventStop(event, scope) {
        return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async evh_6705964765214521_success(event, scope) {
        return await this.actions.evh_6705964765214521_success.executeFromDOM(this, event, scope);
    }
    async evh_6806515264385235_success(event, scope) {
        return await this.actions.evh_6806515264385235_success.executeFromDOM(this, event, scope);
    }
    async evh_5477420070495986_reload(event, scope) {
        return await this.actions.evh_5477420070495986_reload.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_4010 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_4010_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_4009 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_4010,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_4009],
        });
        const act_8320016629450276_reloadComponentData_4012 = new core_1.actions.ReloadComponentDataAction({
            displayName: "reload",
            events: [],
        });
        const evh_8320016629450276_clickPreventStop_4011 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_reloadComponentData_4012,
            event: "click.prevent.stop",
            displayName: "reload",
        });
        const evh_8320016629450276_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_clickPreventStop_4011],
        });
        const act_6705964765214521_closeComponent_4014 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_6705964765214521_success_4013 = new core_1.actions.EventHandlerImpl({
            action: act_6705964765214521_closeComponent_4014,
            event: "success",
            displayName: "closeComponent",
        });
        const evh_6705964765214521_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6705964765214521_success_4013],
        });
        const act_6806515264385235_reloadComponentData_4016 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_6806515264385235_success_4015 = new core_1.actions.EventHandlerImpl({
            action: act_6806515264385235_reloadComponentData_4016,
            event: "success",
            displayName: "reloadComponentData",
        });
        const evh_6806515264385235_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6806515264385235_success_4015],
        });
        const act_5477420070495986_reloadComponentData_4018 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_5477420070495986_reload_4017 = new core_1.actions.EventHandlerImpl({
            action: act_5477420070495986_reloadComponentData_4018,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_5477420070495986_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5477420070495986_reload_4017],
        });
        return {
            act_7315092382398562_closeModal_4010,
            evh_7315092382398562_close_4009,
            evh_7315092382398562_close,
            act_8320016629450276_reloadComponentData_4012,
            evh_8320016629450276_clickPreventStop_4011,
            evh_8320016629450276_clickPreventStop,
            act_6705964765214521_closeComponent_4014,
            evh_6705964765214521_success_4013,
            evh_6705964765214521_success,
            act_6806515264385235_reloadComponentData_4016,
            evh_6806515264385235_success_4015,
            evh_6806515264385235_success,
            act_5477420070495986_reloadComponentData_4018,
            evh_5477420070495986_reload_4017,
            evh_5477420070495986_reload,
            reload: act_8320016629450276_reloadComponentData_4012,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], Product.prototype, "oid", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('oid'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Product.prototype, "onOid", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], Product.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Product.prototype, "onSize", null);
Product = __decorate([
    (0, vue_property_decorator_1.Component)()
], Product);
exports.default = Product;
vue_property_decorator_1.Vue.component("Product", Product);
